module.exports = __webpack_public_path__ + "media/images/hero/hero2-title-45918578799791e8b331f113c46e78a3.svg";